import { useState, useEffect, useCallback } from 'react';

import BaseService from '../services/base.service';

export default function useFetch(url, query) {
  const [dataState, setDataState] = useState({
    data: [],
    error: null,
    loading: true,
  });

  const fetchService = new BaseService();
  const queryString = fetchService.getQueryString(query);

  const handleFetch = useCallback(async () => {
    try {
      const data = await fetchService.get(`${url}${queryString}`);

      setDataState((prev) => ({
        ...prev,
        data,
        loading: false,
      }));

      return data;
    } catch (error) {
      setDataState((prev) => ({
        ...prev,
        error: error.message,
        loading: false,
      }));
      return null;
    }
  }, [query]);

  useEffect(() => {
    if (dataState.data.length === 0) handleFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...dataState,
    handleFetch,
  };
}
